




helpers = require('../../../helpers.coffee')

view_model = {
  props: ['notification', 'table']

  components:
    changeResponsability: require('./kind/change_responsability')
    task: require('./kind/task')
    ozzytask: require('./kind/ozzy_task')
    remind: require('./kind/remind')
    contactPublicApi: require('./kind/contact_public_api')
    createdRdStation: require('./kind/created_rd_station')
    updatedRdStation: require('./kind/updated_rd_station')
    createdSharpSpring: require('./kind/created_sharp_spring')
    updatedSharpSpring: require('./kind/updated_sharp_spring')
    createdLeadLovers: require('./kind/created_lead_lovers')
    updatedLeadLovers: require('./kind/updated_lead_lovers')
    createdPipedrive: require('./kind/created_pipedrive')
    contactInterrupted: require('./kind/contact_interrupted')

  data: ->
    current_user: Session.current_user

  methods:
    remove: (markAsRead=true)->
      @$emit 'remove-notification', @notification.id, markAsRead

    notificationComponent: (notification) ->
      switch notification.kind
        when 'change_responsability' then 'change-responsability'
        when 'task_email' then 'task'
        when 'task_social' then 'task'
        when 'task_linkedin' then 'task'
        when 'task_phonecall' then 'task'
        when 'ozzytask' then 'ozzytask'
        when 'contact_public_api' then 'contact-public-api'
        when 'created_rd_station' then 'created-rd-station'
        when 'updated_rd_station' then 'updated-rd-station'
        when 'created_sharp_spring' then 'created-sharp-spring'
        when 'updated_sharp_spring' then 'updated-sharp-spring'
        when 'created_lead_lovers' then 'created-lead-lovers'
        when 'updated_lead_lovers' then 'updated-lead-lovers'
        when 'created_pipedrive' then 'created-pipedrive'
        when 'remind_ten_minutes' then 'remind'
        when 'remind_thirty_minutes' then 'remind'
        when 'contact_interrupted' then 'contact-interrupted'
        else ''

  created: ->
    setTimeout =>
      @remove(false)
    , 5000
}

exports.default = helpers.vue_include(view_model)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/notifications/list_item.vue